import { useMemo } from 'react';
import { useLoaderData } from 'react-router-dom';

import type { VideosContext } from './shared';

export interface PosthogAttributionData {
  store: string;
  video: string;
  email: string | null;
  phone: string | null;
  firstName: string | null;
  endCustomerId: string | null;
}

export function usePosthogAttributionDataFromLoader(): PosthogAttributionData {
  const { object, storeInfo, customerFirstName, email, phone, endCustomerId } = useLoaderData() as VideosContext;
  return useMemo(
    () => ({
      store: storeInfo.keyName,
      video: object.uniqueId,
      email: email,
      phone: phone,
      firstName: customerFirstName,
      endCustomerId: endCustomerId,
    }),
    [customerFirstName, email, endCustomerId, object.uniqueId, phone, storeInfo.keyName],
  );
}
